import { module } from 'angular';

import { AWS_LOAD_BALANCER_DETAILS_CTRL } from './details/loadBalancerDetails.controller';
import { AWS_LOAD_BALANCER_TRANSFORMER } from './loadBalancer.transformer';
import { AWS_TARGET_GROUP_DETAILS_CTRL } from './details/targetGroupDetails.controller';
import { LOAD_BALANCER_ACTIONS } from './details/loadBalancerActions.component';
import { TARGET_GROUP_STATES } from './targetGroup.states';

export const AWS_LOAD_BALANCER_MODULE = 'spinnaker.amazon.loadBalancer';

module(AWS_LOAD_BALANCER_MODULE, [
  AWS_LOAD_BALANCER_DETAILS_CTRL,
  AWS_LOAD_BALANCER_TRANSFORMER,
  AWS_TARGET_GROUP_DETAILS_CTRL,
  LOAD_BALANCER_ACTIONS,
  TARGET_GROUP_STATES
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/loadBalancer/loadBalancer.module.ts